/** Re-subscribe Firestore listeners when the tab wakes or network returns. */
export const attachReconnectingListener = (subscribe) => {
  let stop = () => {};
  let active = true;

  const connect = () => {
    if (!active) return;
    try { stop(); } catch (_) { /* */ }
    stop = subscribe() || (() => {});
  };

  connect();

  const onWake = () => {
    if (!active || document.visibilityState !== 'visible') return;
    connect();
  };

  document.addEventListener('visibilitychange', onWake);
  window.addEventListener('online', connect);
  window.addEventListener('focus', onWake);
  window.addEventListener('mytownly-reconnect', connect);

  return () => {
    active = false;
    document.removeEventListener('visibilitychange', onWake);
    window.removeEventListener('online', connect);
    window.removeEventListener('focus', onWake);
    window.removeEventListener('mytownly-reconnect', connect);
    try { stop(); } catch (_) { /* */ }
  };
};

export const requestLiveReconnect = () => {
  window.dispatchEvent(new Event('mytownly-reconnect'));
};
